import { FidcElegibilidade, FidcTaxa } from './fidc';

export class ErroTaxasFidc extends Error {}

// Todos é uma opção de edição; a API recebe apenas combinações concretas.
export function expandirTaxasFidc(e: FidcElegibilidade): FidcTaxa[] {
  const resultado = new Map<string, FidcTaxa>();
  for (const taxa of e.taxas) {
    const convenios = taxa.empregador === -1 ? e.empregadores : [taxa.empregador];
    const regimes = taxa.regime === 'TODOS' ? e.regimes : [taxa.regime];
    if (!convenios.length || !regimes.length || convenios.some(id => !e.empregadores.includes(id)) || regimes.some(id => !e.regimes.includes(id))) {
      throw new ErroTaxasFidc('Selecione empregadores e regimes no Cadastro de elegibilidade e revise as taxas vinculadas.');
    }
    for (const empregador of convenios) {
      for (const regime of regimes) {
        const chave = `${empregador}:${regime}:${taxa.jurosOperacao}`;
        const existente = resultado.get(chave);
        if (existente && existente.taxaCessao !== taxa.taxaCessao) {
          throw new ErroTaxasFidc('Há taxas de cessão diferentes para o mesmo empregador, regime e juros. Revise as linhas com Todos e as regras individuais.');
        }
        resultado.set(chave, { ...taxa, empregador, regime });
      }
    }
  }
  return Array.from(resultado.values());
}
